module.exports = __webpack_public_path__ + "media/images/front/icon_up_green-77077b116020bf8a7ba17709ea04110a.png";